<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col md="12">
        <b-card>
          <div slot="header">
            <strong><i class="fa fa-list"></i> Statistiques</strong>
          </div>
            <b-tabs>
              <b-tab active>
                <template slot="title">
                  <i class="cui-comment-square"></i>
                  {{ tabs[0] }}
                </template>
                <contact-stats></contact-stats>
              </b-tab>
              <b-tab>
                <template slot="title">
                  <i class="icon-list"></i>
                  {{ tabs[1] }}
                </template>
                <faq-stats></faq-stats>
              </b-tab>
            </b-tabs>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import ContactStats from './ContactStats'
import FaqStats from './FaqStats'
import { getBaseUrl, getProvider, getIdToken, getAccessToken } from '../../utils/auth'

export default {
	components: { ContactStats, FaqStats },
  data() {
    return {
      tabs: ["Contacts", "Faq"]
    }
  }
}
</script>

<style>
  /* body {
    background-image: url("/../../../img/brand/montagne.jpg");
    background-repeat: no-repeat;
    background-size: cover;
  } */
</style>
